// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Registo do Amigo',
  intro:
    'Todos os pedidos tratados pelo Amigo: o que foi pedido, onde, quem pediu e quem aprovou. Só a FoodAmigos vê esta página.',
  // The tab list's name for screen readers.
  tabs_label: 'Registo do Amigo',
  tabs: {
    requests: 'Pedidos',
    gaps: 'Não foi possível',
  },
  filters: {
    restaurant: 'Restaurante',
    all_restaurants: 'Todos os restaurantes',
    brand: '{{name}} · Marca',
    restaurant_unknown: 'Restaurante {{id}}',
    searching: 'A procurar restaurantes…',
    no_restaurant: 'Nenhum restaurante chamado “{{query}}”',
    period: 'Período',
    start_date: 'Data de início',
    end_date: 'Data de fim',
    refresh: 'Atualizar',
    gap: 'Pedido: {{request}}',
    change_set: 'O pedido por trás de uma alteração',
    remove: 'Remover o filtro: {{label}}',
    clear: 'Limpar filtros',
  },
  columns: {
    steps: 'Passos',
    when: 'Quando',
    request: 'Pedido',
    restaurant: 'Restaurante',
    asked_by: 'Pedido por',
    result: 'Resultado',
  },
  show_steps: 'Mostrar os passos de: {{request}}',
  approved_by: 'Aprovado por {{name}}',
  nothing_approved: 'Nada aprovado',
  results: {
    applied: '{{applied}} aplicadas',
    applied_skipped: '{{applied}} aplicadas · {{skipped}} ignoradas',
    partial: '{{applied}} de {{total}} aplicadas',
    imported: 'Importado',
    importing: 'A importar',
    waiting: 'A aguardar aprovação',
    rejected: 'Rejeitado',
    undone: 'Anulado',
    partly_undone: '{{undone}} de {{total}} anuladas',
    expired: 'Expirado',
    replaced: 'Substituído',
    failed: 'Falhou',
    answered: 'Respondido',
    not_yet: 'Ainda não foi possível',
    off_limits: 'Fora dos limites',
    not_allowed: 'Não permitido',
    switched_off: 'Desativado',
    guard: 'Interrompido por uma verificação de segurança',
    not_found: 'Não encontrado',
  },
  steps: {
    asked: '{{name}} pediu',
    asked_anonymous: 'Pedidos',
    approved: 'Aprovado por {{name}}',
    approved_alone: 'Aprovado',
    applied_one: '{{count}} alteração aplicada',
    applied_other: '{{count}} alterações aplicadas',
    failed_one: '{{count}} não aplicadas',
    failed_other: '{{count}} não aplicadas',
    rejected: 'Rejeitado',
    undone: 'Anulado',
    undone_by: 'Anulado, aprovado por {{name}}',
    skipped_one: '{{count}} ignorados',
    skipped_other: '{{count}} ignorados',
    skipped_state: 'Ignorado',
    more_one: 'e mais {{count}}',
    more_other: 'e mais {{count}}',
    changes_one: '{{count}} alteração',
    changes_other: '{{count}} alterações',
    other: 'A verificar algo',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} passo',
    steps_other: '{{count}} passos',
    refused_one: '{{count}} recusados',
    refused_other: '{{count}} recusados',
    failed_one: '{{count}} com falha',
    failed_other: '{{count}} com falha',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Resultado',
    answered: 'Uma resposta: nada foi alterado.',
    waiting: 'A aguardar aprovação. Ainda nada foi alterado.',
    rejected: 'Rejeitado: nada foi alterado.',
    expired: 'Expirou sem aprovação: nada foi alterado.',
    replaced: 'Substituído por um cartão mais recente: nada foi alterado aqui.',
    undone: 'Anulado: as alterações foram revertidas.',
    partly_undone: 'Parcialmente anulado: {{undone}} de {{total}} alterações foram revertidas.',
    failed: 'Falhou: nada foi alterado.',
    not_yet: 'Ainda não foi possível: nada foi alterado. Contabilizado em Não foi possível.',
    off_limits: 'Fora dos limites: nada foi alterado.',
    not_allowed: 'Não permitido para a função desta pessoa: nada foi alterado.',
    switched_off: 'Desativado aqui: nada foi alterado.',
    guard: 'Interrompido por uma verificação de segurança: nada foi alterado.',
    not_found: 'Não encontrado: nada foi alterado.',
    importing: 'A importar. Cada prato vai para Menu → Histórico de edições.',
    imported: 'Importado. Cada prato está em Menu → Histórico de edições.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} alteração',
    title_other: '{{count}} alterações',
    show_all: 'Mostrar as {{count}} alterações',
    show_fewer: 'Mostrar menos',
    from: 'de',
    to: 'para',
    removed: 'Removido',
  },
  row_states: {
    skipped: 'Ignorado',
    failed: 'Não aplicado',
    stale: 'Alterado entretanto',
    kept: 'Mantido como está',
  },
  menu_history: 'Abra Menu → Histórico de edições',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Abrir o chat',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Não foi possível abrir esse restaurante. Tente novamente.',
  pagination: {
    label: 'Páginas',
    summary: '{{from}}–{{to}} de {{total}} pedidos',
    previous: 'Página anterior',
    next: 'Página seguinte',
  },
  empty: {
    title: 'Sem pedidos para {{restaurant}} neste período',
    text: 'O Amigo não tratou nada aí entre {{from}} e {{to}}.',
    title_any_day: 'Ainda sem pedidos para {{restaurant}}',
    text_any_day: 'O Amigo ainda não tratou nada aí.',
    title_everywhere: 'Sem pedidos neste período',
    text_everywhere: 'O Amigo não tratou nada entre {{from}} e {{to}}.',
    title_nothing: 'Ainda sem pedidos',
    text_nothing: 'O Amigo ainda não tratou nada.',
  },
  loading: 'A carregar…',
  error: {
    title: 'Não foi possível carregar o registo',
    text: 'Tente novamente dentro de instantes.',
    retry: 'Tentar novamente',
  },
  gaps: {
    intro:
      'O que o Amigo ainda não conseguiu fazer, agrupado por pedido, do mais frequente para o menos frequente. Pedidos fora dos limites e pedidos que uma função não permite não aparecem aqui.',
    columns: {
      area: 'Área',
      request: 'O que as pessoas pediram',
      count: 'Pedidos',
      last_at: 'Último pedido',
      requests: 'Pedidos',
    },
    count: '{{count}}×',
    see_requests_one: 'Ver {{count}} pedido',
    see_requests_other: 'Ver {{count}} pedidos',
    today: 'Hoje, {{time}}',
    yesterday: 'Ontem, {{time}}',
    empty_title: 'Sem pedidos que o Amigo não conseguiu tratar',
    empty_text: 'O Amigo conseguiu tratar tudo o que lhe pediram.',
  },
  areas: {
    menu: 'Menu',
    hours: 'Horário de funcionamento',
    order_settings: 'Definições de pedidos',
    my_info: 'Os meus dados',
    marketing: 'Marketing',
    gift_cards: 'Cartões-presente',
    reports: 'Relatórios',
    website: 'Website',
    integrations: 'Integrações',
    delivery: 'Entregas',
    payments: 'Pagamentos',
    team: 'Equipa',
    billing: 'Faturação',
    settings: 'Definições',
    other: 'Outro',
  },
};
